import { IconButton, InputAdornment, TextField } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import React from "react";

function ErrorAdornment(props) {
    return (
        <InputAdornment position="end">
            <IconButton aria-label="error warning" size="small">
                <WarningIcon color="error" fontSize="small" />
            </IconButton>
        </InputAdornment>
    );
}

interface ITextFieldProps {
    id: string;
    type: string;
    fullWidth: boolean;
    label: string;
    placeholder: string;
    helperText: string;
    error: boolean;
    required: boolean;
    onChange?: (e: any) => void;
    other?: any;
    autoFocus?: boolean;
    autoComplete?: string;
}

export default function AcxTextField(props: ITextFieldProps) {
    let InputProps = {
        endAdornment: ErrorAdornment({ color: "red" }),
        sx: {
            "& .MuiOutlinedInput-root": {
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: (theme) => theme.palette.blue.main,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: (theme) => theme.palette.blue.main,
                },
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: (theme) => theme.palette.black.main,
                },
            },
        },
    };
    const InputLabelProps = {
        sx: {
            "&.Mui-focused": {
                color: (theme) => theme.palette.blue.main,
            },
            "&.Mui-error": {
                color: (theme) => theme.palette.secondary.main,
            },
            "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -14px) scale(0.75) !important",
            },
            "&.MuiInputLabel-marginDense": {
                transform: "translate(14px, 4px) scale(1)",
            },
        },
    };
    const getProps = () => {
        if (!props.error) {
            // @ts-ignore
            delete InputProps.endAdornment;
        }
        return InputProps;
    };

    return (
        <TextField
            id={props.id}
            type={props.type}
            label={props.label}
            placeholder={props.placeholder}
            variant="outlined"
            fullWidth={props.fullWidth}
            required={props.required}
            autoFocus={props.autoFocus}
            error={props.error}
            helperText={props.helperText}
            onChange={props.onChange}
            margin="dense"
            InputLabelProps={InputLabelProps}
            InputProps={getProps()}
            autoComplete={props.autoComplete}
            {...props.other}
        />
    );
}

AcxTextField.defaultProps = {
    autoFocus: false,
    placeholder: "",
    helperText: "",
    error: "",
    fullWidth: false,
    required: false,
};
